/**
 * @generated SignedSource<<f64dcad2df963ef36c6d6ad651560991>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useAiCreateProjectContextQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly issueTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly small: string | null;
          } | null;
          readonly fieldsConfiguration: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly components?: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly componentId: string;
                      readonly name: string | null;
                    } | null;
                  } | null> | null;
                } | null;
                readonly fieldConfig?: {
                  readonly isEditable: boolean | null;
                  readonly isRequired: boolean | null;
                } | null;
                readonly fieldId: string;
                readonly name: string;
                readonly type: string;
              } | null;
            } | null> | null;
          } | null;
          readonly hierarchy: {
            readonly level: number | null;
          } | null;
          readonly issueTypeId: string | null;
          readonly name: string;
        } | null;
      } | null> | null;
    } | null;
    readonly key: string;
    readonly projectId: string | null;
  } | null;
  readonly " $fragmentType": "useAiCreateProjectContextQuery";
};
export type useAiCreateProjectContextQuery$key = {
  readonly " $data"?: useAiCreateProjectContextQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAiCreateProjectContextQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectIdOrKey"
    }
  ],
  "kind": "Fragment",
  "name": "useAiCreateProjectContextQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "idOrKey",
          "variableName": "projectIdOrKey"
        }
      ],
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "jira_projectByIdOrKey",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "JiraIssueTypeConnection",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "issueTypeId"
                    },
                    (v0/*: any*/),
                    {
                      "concreteType": "JiraIssueTypeHierarchyLevel",
                      "kind": "LinkedField",
                      "name": "hierarchy",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "level"
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraAvatar",
                      "kind": "LinkedField",
                      "name": "avatar",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "small"
                        }
                      ]
                    },
                    {
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsConfiguration",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "__typename"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "type"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "fieldId"
                                },
                                (v0/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "JiraFieldConfig",
                                      "kind": "LinkedField",
                                      "name": "fieldConfig",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "isEditable"
                                        },
                                        {
                                          "kind": "ScalarField",
                                          "name": "isRequired"
                                        }
                                      ]
                                    }
                                  ],
                                  "type": "JiraIssueFieldConfiguration",
                                  "abstractKey": "__isJiraIssueFieldConfiguration"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponentConnection",
                                      "kind": "LinkedField",
                                      "name": "components",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "concreteType": "JiraComponentEdge",
                                          "kind": "LinkedField",
                                          "name": "edges",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "concreteType": "JiraComponent",
                                              "kind": "LinkedField",
                                              "name": "node",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "name": "componentId"
                                                },
                                                (v0/*: any*/)
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "type": "JiraComponentsField"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "3645fad7b26174038e7b4e48448e2bfa";

export default node;
